import { Colors, Router, Storage, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import { Column } from '@lightningjs/ui-components';

//API
import { updateProfile } from '../../../api/profiles';

//Components
import AuthRoute from '../../../components/layouts/AuthRoute/AuthRoute';
import ChooseAvatar from './components/ChooseAvatar';
import Button from './components/Button';
import Keyboard from '../../../components/Keyboard/components/Keyboard';

let profileInfo = {};
export default class EditSingleProfile extends AuthRoute {
  static _template() {
    return {
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Title: {
        y: 195,
        x: 317,
        text: {
          text: 'Edit Profile',
          fontFace: 'OpenSans-SemiBold',
          fontSize: 60,
          textColor: Colors('#FAFAFA').get(),
        },
      },
      ProfileName: {
        collision: true,
        type: Column,
      },
      Keyboard: {
        type: Keyboard,
        y: 800,
        w: 1920,
        rect: true,
        color: Colors('#000000').alpha(0).get(),
        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
        visible: false,
        limit: 20,
      },
      ChooseAvatar: {
        collision: true,
        type: ChooseAvatar,
      },
      Language: {
        collision: true,
        type: Column,
      },
      Autoplay: {
        collision: true,
        type: Column,
      },
      Picture: {
        type: Column,
      },
      Button: {
        collision: true,
        type: Button,
      },
    };
  }
  _enable() {
    profileInfo = Storage.get(this._params.profileId);
    this._Keyboard.visible = false;
    this._setState('ProfileName');
  }

  onInputChanged({ input }) {
    profileInfo = Storage.get(this._params.profileId);
    Storage.set(this._params.profileId, { ...profileInfo, profileName: input });
    this._input = input;
    this._Input.text = input;
  }
  set params({ profileId }) {
    return (this._params = { profileId });
  }
  get _ProfileAutoplay() {
    return this.tag('Autoplay').items[0]?.tag('CurrentValue').text._text;
  }
  get _Input() {
    return this.tag('ProfileName').items[0]?.tag('Input');
  }
  get _InputField() {
    return this.tag('ProfileName').items[0]?.tag('InputWrapper');
  }
  get _ChooseAvatar() {
    return this.tag('ChooseAvatar');
  }
  get _Title() {
    return this.tag('Title');
  }
  get _Autoplay() {
    return this.tag('Autoplay');
  }
  get _Language() {
    return this.tag('Language');
  }
  get _ProfileName() {
    return this.tag('ProfileName');
  }
  get _Keyboard() {
    return this.tag('Keyboard');
  }
  get _Picture() {
    return this.tag('Picture');
  }

  _changePlaceholder() {
    this.tag('ProfileName').items[0]?._changePlaceholder();
  }

  $addInputListen() {
    this._InputField.tag('Input').listening = true;
  }

  $removeInputListe() {
    this._InputField.tag('Input').listening = false;
  }

  _handleBack() {
    if (this._Keyboard.visible) {
      this._Keyboard.visible = false;
      this._setState('ProfileName');
    } else {
      Router.back();
    }
  }

  $setState(state) {
    this._setState(state);
  }
  static _states() {
    return [
      class ProfileName extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('ProfileName');
        }
        _handleEnter() {
          this._Keyboard.visible = true;
          this._setState('Keyboard');
          this.$addInputListen();
        }

        _handleClick() {
          this._handleEnter();
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          if (this._Keyboard.visible) this._setState('Keyboard');
        }
        _handleDown() {
          this._setState('ChooseAvatar');
        }
      },
      class Keyboard extends this {
        _getFocused() {
          this.$addInputListen();
          return this._Keyboard;
        }
        _handleUp() {
          this._setState('ProfileName');
          this._Keyboard.visible = false;
          this.$removeInputListe();
        }
        _handleRight() {
          return;
        }
      },
      class ChooseAvatar extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('ChooseAvatar');
        }
        _handleEnter() {
          Router.navigate('profile/choose-avatar', { profileId: this._params.profileId });
        }

        _handleClick() {
          this._handleEnter();
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          return this._setState('ProfileName');
        }
        _handleDown() {
          return this._setState('Language');
        }
      },
      class Language extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('Language');
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          return this._setState('ChooseAvatar');
        }
        _handleDown() {
          return this._setState('Autoplay');
        }
      },
      class Autoplay extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('Autoplay');
        }
        _handleRight() {
          return this._setState('Button');
        }
        _handleUp() {
          return this._setState('Language');
        }

        _handleDown() {
          if (this._Keyboard.visible) {
            this._setState('Keyboard');
          }
        }
      },
      class Button extends this {
        _getFocused() {
          this.$removeInputListe();
          return this.tag('Button');
        }
        _updateProfile() {
          if (this._InputField.tag('Input').value === '') {
            return;
          }
          profileInfo = Storage.get(this._params.profileId);

          switch (this._ProfileAutoplay) {
            case 'On':
              Storage.set(this._params.profileId, { ...profileInfo, profileAutoplay: true });
              break;
            case 'Off':
              Storage.set(this._params.profileId, { ...profileInfo, profileAutoplay: false });
          }
          profileInfo = Storage.get(this._params.profileId);
          let profile = {
            avatar_id: profileInfo.avatar_id,
            first_name: this._InputField.tag('Input').value,
            native_language: profileInfo.profileLanguage,
            autoplay: profileInfo.profileAutoplay,
          };

          updateProfile(this._params.profileId, profile)
            .then((response) => {
              Router.navigate('profile');
            })
            .catch((error) => {
              console.error('Failed to update profile', error);
            });
        }
        _handleEnter() {
          this._updateProfile();
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleDown() {
          if (this._Keyboard.visible) {
            this._setState('Keyboard');
          }
        }
        _handleLeft() {
          this._setState('ProfileName');
        }
      },
    ];
  }
}
